export const CAMPAIGN_VIEW_REQUEST = "CAMPAIGN_VIEW_REQUEST";
export const CAMPAIGN_VIEW_FAIL = "CAMPAIGN_VIEW_FAIL";
export const CAMPAIGN_VIEW_SUCCESS = "CAMPAIGN_VIEW_SUCCESS";

export const CATEGORY_VIEW_REQUEST = "CATEGORY_VIEW_REQUEST";
export const CATEGORY_VIEW_FAIL = "CATEGORY_VIEW_FAIL";
export const CATEGORY_VIEW_SUCCESS = "CATEGORY_VIEW_SUCCESS";

export const TEAM_VIEW_REQUEST = "TEAM_VIEW_REQUEST";
export const TEAM_VIEW_FAIL = "TEAM_VIEW_FAIL";
export const TEAM_VIEW_SUCCESS = "TEAM_VIEW_SUCCESS";

export const FEATURE_VIEW_REQUEST = "FEATURE_VIEW_REQUEST";
export const FEATURE_VIEW_FAIL = "FEATURE_VIEW_FAIL";
export const FEATURE_VIEW_SUCCESS = "FEATURE_VIEW_SUCCESS";

export const PARTNER_VIEW_REQUEST = "PARTNER_VIEW_REQUEST";
export const PARTNER_VIEW_FAIL = "PARTNER_VIEW_FAIL";
export const PARTNER_VIEW_SUCCESS = "PARTNER_VIEW_SUCCESS";

export const STORY_VIEW_REQUEST = "STORY_VIEW_REQUEST";
export const STORY_VIEW_FAIL = "STORY_VIEW_FAIL";
export const STORY_VIEW_SUCCESS = "STORY_VIEW_SUCCESS";

export const CONTENT_VIEW_REQUEST = "CONTENT_VIEW_REQUEST";
export const CONTENT_VIEW_FAIL = "CONTENT_VIEW_FAIL";
export const CONTENT_VIEW_SUCCESS = "CONTENT_VIEW_SUCCESS";

export const ADVISORY_VIEW_REQUEST = "ADVISORY_VIEW_REQUEST";
export const ADVISORY_VIEW_FAIL = "ADVISORY_VIEW_FAIL";
export const ADVISORY_VIEW_SUCCESS = "ADVISORY_VIEW_SUCCESS";

export const LANG_VIEW_REQUEST = "LANG_VIEW_REQUEST";
export const LANG_VIEW_FAIL = "LANG_VIEW_FAIL";
export const LANG_VIEW_SUCCESS = "LANG_VIEW_SUCCESS";

export const CONTACT_VIEW_REQUEST = "CONTACT_VIEW_REQUEST";
export const CONTACT_VIEW_FAIL = "CONTACT_VIEW_FAIL";
export const CONTACT_VIEW_SUCCESS = "CONTACT_VIEW_SUCCESS";

export const ADMIN_VIEW_REQUEST = "ADMIN_VIEW_REQUEST";
export const ADMIN_VIEW_FAIL = "ADMIN_VIEW_FAIL";
export const ADMIN_VIEW_SUCCESS = "ADMIN_VIEW_SUCCESS";

export const TRANSACTION_VIEW_REQUEST = "TRANSACTION_VIEW_REQUEST";
export const TRANSACTION_VIEW_FAIL = "TRANSACTION_VIEW_FAIL";
export const TRANSACTION_VIEW_SUCCESS = "TRANSACTION_VIEW_SUCCESS";

export const PARTNER_CONTACT_VIEW_REQUEST = "PARTNER_CONTACT_VIEW_REQUEST";
export const PARTNER_CONTACT_VIEW_FAIL = "PARTNER_CONTACT_VIEW_FAIL";
export const PARTNER_CONTACT_VIEW_SUCCESS = "PARTNER_CONTACT_VIEW_SUCCESS";

export const FAQ_VIEW_REQUEST = "FAQ_VIEW_REQUEST";
export const FAQ_VIEW_FAIL = "FAQ_VIEW_FAIL";
export const FAQ_VIEW_SUCCESS = "FAQ_VIEW_SUCCESS";
